export function OnContinueChat(apiUtils) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    return () => { apiUtils.submitReportingEvent('Continue', 'User'); };
}
export function OnEndChat(apiUtils, almeState, setAlmeAppState) {
    return (initiator) => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        apiUtils.submitReportingEvent('TerminateSession', initiator);
        if (initiator === "System") {
            setAlmeAppState(Object.assign(Object.assign({}, almeState), { isLiveChatSessionTimeout: true }));
        }
    };
}
export async function TerminateLiveChat(apiUtils, almeState) {
    if (almeState.isLiveChatConnected) {
        await apiUtils.submitReportingEvent('TerminateSession', 'System');
    }
}
